import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import Global from '../../store/global-selectors';
import { emptyArray } from 'ui-components/default-props/empty';

export const useConfirmationTypesForService = (serviceId) => {
  const selectedService = useSelector((state) => Global.selectSellerServiceById(state, { serviceId }));
  const carrierId = selectedService?.carrierId || '';

  const carriers = useSelector(Global.selectReferenceDatagetSellerCarriers);
  const carrierInfo = useMemo(() => {
    return carriers.find((carrier) => carrier.carrierId === carrierId);
  }, [carrierId, carriers]);

  const carrierConfirmationTypes = carrierInfo?.confirmations || emptyArray;

  const memoizedConfirmationTypes = useMemo(
    () =>
      carrierConfirmationTypes.map((conf) => {
        return {
          confirmationOptionId: conf.confirmationId,
          name: conf.name,
        };
      }),
    [carrierConfirmationTypes],
  );

  return memoizedConfirmationTypes;
};
